
import axios from "../config/axios.config";


export const getRequest = async (url, params = {}) => {
  try {
    const response = await axios.get(url, { params: { ...params } });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};



export const errorHandler = (error) => {
  let message = "An unknown error occurred.";
  if (error.response) {
    const res = error.response.data;

    if (error.response.status === 401) {
      alert("Session expired. Please log in again.");
      // errorToaster(warningMessages.sessionExpired);
    } else {
      // alert("Something went wrong. Please try again later.");
      // errorToaster(errorMessages.somethingWentWrong);
    }
    if (res) {
      message = res.message || res.metadata?.message || message;
    } else {
      message = JSON.stringify(res);
    }
  } else if (error?.message) {
    message = error.message;
    alert(message);
    // errorToaster(message);
  }
  return { error: message };
};